import { render, staticRenderFns } from "./TitleAndDescription.vue?vue&type=template&id=8097a5ec"
import script from "./TitleAndDescription.vue?vue&type=script&lang=js"
export * from "./TitleAndDescription.vue?vue&type=script&lang=js"
import style0 from "./TitleAndDescription.vue?vue&type=style&index=0&id=8097a5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports